export const FETCH_MORE_PAGE_SIZE = 5;
export const COMMENT_COLLAPSE_THRESHOLD = 85;

export const onboardingFeedHeaderCard = 'home.feed.header.onboarding.followed-for-you';
